<div class="chart-component">

  <chart-header
    [totalConsumption]="totalConsumption"
    (exportCsv)="exportCsv()"
    (timeRangeChange)="onTimeRangeChanged($event)"
  >

  </chart-header>
  <div class="chart-container">
    <canvas baseChart
            [data]="lineChartData"
            [options]="lineChartOptions"
            [type]="'line'">
    </canvas>
  </div>
</div>
